import React, { useEffect } from 'react';
import { Grid, Box, TextField, Container } from '@mui/material';
import { Icons } from 'components/Icons';
import AlertAlt from 'components/AlertAlt';
import { PaymentMethodEnum, CouponStatusEnum, GatewayEnum } from 'enums';
import { useStyles } from './styles';
import CustomButton from 'components/CustomButton';
import BillingCycle from './BillingCycle';
import CheckoutProcessInformation from './CheckoutProcessInformation';
import OrderSummary from './OrderSummary';
import { CouponPropType } from './types';
import PaymentMethods from './PaymentMethods';
import { useCheckoutContext } from 'contexts/CheckoutContext';

const Props = {
  coupon: CouponPropType,
};

export default function Checkout(props) {
  const classes = useStyles();
  const { data, actions } = useCheckoutContext();

  const handleSubmit = () => {
    const hasForm =
      data.paymentMethod === PaymentMethodEnum.CARD ||
      data.paymentMethod === PaymentMethodEnum.SEPA_DEBIT;

    if (hasForm) {
      data.formRef.current.click();
      return;
    }

    actions.onSubmit();
  };

  useEffect(() => {
    if (props.coupon && props.coupon.status === CouponStatusEnum.AVAILABLE) {
      actions.setCoupon(props.coupon);

      if (props.coupon.gateway === GatewayEnum.STRIPE) {
        actions.setPaymentMethod(PaymentMethodEnum.CARD);
      }

      if (props.coupon.gateway === GatewayEnum.PAYPAL) {
        actions.setPaymentMethod(PaymentMethodEnum.PAYPAL);
      }

      if (props.coupon.plan) {
        actions.setPlan(props.coupon.plan);
      }

      if (props.coupon.billingInterval) {
        actions.setBillingInterval(props.coupon.billingInterval);
      }
    }
  }, [props]);

  return (
    <Container>
      <Grid container={true} spacing={2} justifyContent="center">
        <CheckoutProcessInformation />

        <Grid item={true} xs={12} md={8} className={classes.paymentGrid}>
          <Box pb={2}>
            <BillingCycle />
          </Box>

          <PaymentMethods />
        </Grid>

        <Grid item={true} xs={12} md={4} className={classes.checkoutGrid}>
          <OrderSummary />

          {data.coupon && (
            <Box my={2}>
              <TextField
                fullWidth={true}
                variant="outlined"
                label="Coupon"
                name="coupon"
                disabled={true}
                value={data.coupon.code}
              />
            </Box>
          )}

          {data.errorMessage && (
            <Box my={3}>
              <AlertAlt severity="error">{data.errorMessage}</AlertAlt>
            </Box>
          )}

          <div>
            <Box className={classes.paymentButtonContainer} mt={3}>
              <CustomButton
                disabled={data.isBusy || data.hasFormError}
                onClick={handleSubmit}
                style={{ width: '100%' }}
              >
                <Icons.verifiedUserOutlined height={24} width={24} />
                Complete Subscription
              </CustomButton>
            </Box>
          </div>

          <Box className={classes.checkoutDisclaimer}>
            <p>
              By continuing, you agree to our{' '}
              <a href="https://mindthegraph.com/blog/faq/terms-of-use/" target="_blank">
                Terms of Use and Privacy Policy
              </a>
              . Your subscription will automatically renew at the end of every billing cycle. You
              can cancel your subscription at any time.
            </p>
          </Box>
        </Grid>
      </Grid>
    </Container>
  );
}

Checkout.propTypes = Props;
